'use client'

import { UnifiedError } from "@/components/common/unified-error"


export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html>
      <body>
        <div className="flex items-center justify-center min-h-screen p-4">
          <UnifiedError
            error={error}
            reset={reset}
            title="Application Error"
            className="w-full max-w-md"
            variant="default"
          />
        </div>
      </body>
    </html>
  )
}
